import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchDoctorsData } from "../../features/Doctors/Doctor";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";
import { t } from "i18next";
import { useTranslation } from "react-i18next";
import CardDoctor from "./CardDoctor";
import Loading from "../Loading";
import Tabs from "../Tabs/Tabs";

function AllDoctorPage() {
  const [countryId, setCountryId] = useState("all");
  const dispatch = useDispatch();
  const [perPage, setPerPage] = useState(8);
  const { doctors, teams, loading } = useSelector((state) => state.doctors);
  const { i18n, t } = useTranslation();
  const handleScroll = useCallback(() => {
    if (
      window.innerHeight + document.documentElement.scrollTop + 124 >=
      document.documentElement.offsetHeight &&
      doctors.length >= perPage
    ) {
      setPerPage((prev) => prev + 8);
    }
  }, [doctors.length, perPage]);

  useEffect(() => {
    dispatch(fetchDoctorsData({ perPage, countryId }));
  }, [dispatch, perPage, i18n.language, countryId]);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        when: "beforeChildren"
      }
    }
  };

  const [mergedData, setMergedData] = useState([]);

  useEffect(() => {
    if (!doctors && !teams) return;

    // tag each item so you still know where it came from
    const tempTeams = (teams || []).map(team => ({
      ...team,
      type: "team"
    }));
    const tempDoctors = (doctors || []).map(doc => ({
      ...doc,
      type: "doctor"
    }));

    // merge and sort by surgery descending
    const merged = [...tempDoctors, ...tempTeams].sort((a, b) => {
      // if surgery is ever a string, coerce to number:
      const surgA = Number(a.surgery) || 0;
      const surgB = Number(b.surgery) || 0;
      return surgB - surgA;
    });

    setMergedData(merged);
  }, [doctors, teams]);


  return (
    <div className="mx-auto my-3 mt-10 w-10/12 md:w-11/12 lg:w-10/12 xl:w-11/12 2xl:w-10/12">
      <div className="flex justify-center mt-4">
        <Tabs setCountryId={setCountryId} />
      </div>


      <motion.div
        variants={containerVariants}
        initial="hidden"
        animate="visible"
        className="grid grid-cols-1 w-full  py-6 gap-4  md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-4 "
      >
        <AnimatePresence>
          {mergedData?.map((doctor) => {
            const type = doctor?.type == null ? "doctor" : doctor?.type
            return (

              <Link to={`/doctors/${doctor.id}/${type}`} className="w-full " key={doctor.id}>
                <CardDoctor

                  doctor={doctor} t={t} i18n={i18n}
                />
              </Link>
            );
          })}
        </AnimatePresence>
      </motion.div>

      {loading && (
        <Loading />
      )}
    </div>
  );
}

export default AllDoctorPage;